
const EndDot = ({ style={} }) => (
  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', padding: '3rem', ...style }}>
    <div style={{ backgroundColor: 'grey', height: '0.15rem', width: '0.15rem', borderRadius: '100%' }} />
  </div>
)

export default EndDot
